module.exports = __webpack_public_path__ + "img/great_communication.a3be9610.svg";